module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-004"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Select bibliography")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Albright, W. F. (1950–51), ‘A Catalogue of Early Hebrew Lyric Poems’, "), _c('i', [_vm._v("HUCA ")]), _vm._v("23: 1–39.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Allender, D. B. and T. Longman III (1994), "), _c('i', [_vm._v("The Cry of the Soul: How Our Emotions Reveal Our Deepest Questions about God ")]), _vm._v("(Colorado Springs, CO: NavPress).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-003"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Alter, R. (1985), "), _c('i', [_vm._v("The Art of Biblical Poetry ")]), _vm._v("(New York: Basic Books).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-004"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Anderson, J. (1981), ‘Introductory Notice’, in "), _c('i', [_vm._v("Joshua. Psalms 1–35 ")]), _vm._v("by John Calvin, Calvin’s Commentaries 4, reprint edn (Grand Rapids: Baker Books), p. vi.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-005"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Beale, G. K. and D. A. Carson (eds.) (2007), "), _c('i', [_vm._v("Commentary on the New Testament Use of the Old Testament ")]), _vm._v("(Grand Rapids: Baker; Nottingham: Apollos).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-006"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Berlin, A. (2009), "), _c('i', [_vm._v("The Dynamics of Biblical Parallelism")]), _vm._v(", 2nd edn (Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-007"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Block, D. I. (2011), "), _c('i', [_vm._v("How I Love Your Torah, O Lord! ")]), _vm._v("(Eugene, OR: Cascade Books).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-008"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Bonhoeffer, D. (1954), "), _c('i', [_vm._v("Life Together ")]), _vm._v("(New York: Harper & Brothers).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-009"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Boström, L. (1990), "), _c('i', [_vm._v("The God of the Sages: The Portrayal of God in the Book of Proverbs")]), _vm._v(", Coniectanea Biblica Old Testament Series 29 (Stockholm: Almqvist and Wiksell International).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-010"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Bouzard, W. C. (1997), "), _c('i', [_vm._v("We Have Heard with Our Ears, O God: Sources of the Communal Laments in the Psalms ")]), _vm._v("(Atlanta: Scholars’ Press).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-011"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Brown, M. L. (1995), "), _c('i', [_vm._v("Israel’s Divine Healer ")]), _vm._v("(Grand Rapids: Zondervan).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-012"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Brown, W. P. (2010), ‘The Metaphorical Theology of Psalms 15 – 24’, in E. Zenger (ed.), "), _c('i', [_vm._v("The Composition of the Book of Psalms")]), _vm._v(" (Leuven: Uitgeverij Peeters), 259–277.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-013"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Broyles, C. C. (1999), "), _c('i', [_vm._v("Psalms")]), _vm._v(", NIBC (Peabody, MA: Hendrikson).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-014"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("––– (2005), ‘The Psalms and Cult Symbolism: The Case of the Cherubim-Ark’, in P. S. Johnston and D. G. Firth (eds.), "), _c('i', [_vm._v("Interpreting the Psalms: Issues and Approaches ")]), _vm._v("(Downers Grove: IVP; Leicester: Apollos), 139–156.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-015"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Brueggemann, W. (1995), "), _c('i', [_vm._v("The Psalms and the Life of Faith")]), _vm._v(", ed. P. D. Miller (Minneapolis: Augsburg Fortress).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-016"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Carson, D. A. (1991), "), _c('i', [_vm._v("The Gospel According to John")]), _vm._v(", PNTC (Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-017"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Childs, B. S. (1962), "), _c('i', [_vm._v("Memory and Tradition in Israel")]), _vm._v(", SBT 37 (London: SCM Press).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-018"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Cimosa, M. (2010), ‘The Greek Psalms in the New Testament’, in E. Zenger (ed.), "), _c('i', [_vm._v("The Composition of the Book of Psalms ")]), _vm._v("(Leuven: Uitgeverij Peeters), 425–441.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-019"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Cohen, D. J. (2013), "), _c('i', [_vm._v("Why O Lord? Praying Our Sorrows ")]), _vm._v("(Milton Keynes: Paternoster).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-020"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Cole, R. L. (2000), "), _c('i', [_vm._v("The Shape and Message of Book III (Psalms 73 – 89)")]), _vm._v(", JSOTSup 307 (Sheffield: Sheffield Academic Press).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-021"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Craigie, P. C. (1972), ‘Psalm XXIX in the Hebrew Poetic Tradition’, "), _c('i', [_vm._v("VT ")]), _vm._v("22: 143–151.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-022"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Creach, J. F. D. (1996), "), _c('i', [_vm._v("Yahweh as Refuge and the Editing of the Hebrew Psalter")]), _vm._v(", JSOTSup 217 (Sheffield: Sheffield Academic Press).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-023"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Cross, F. M. (1950), ‘Notes on a Canaanite Psalm in the Old Testament’, "), _c('i', [_vm._v("BASOR ")]), _vm._v("17: 19–21.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-024"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Crow, L. D. (1996), "), _c('i', [_vm._v("The Songs of Ascent (Psalms 120–134): Their Place in Israelite History and Religion ")]), _vm._v("(Atlanta: Scholars’ Press).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-025"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Curtis, A. H. W. (1978), ‘The “Subjugation of the Waters” Motif in the Psalms: Imagery or Polemic?’, "), _c('i', [_vm._v("JSS ")]), _vm._v("23: 244–256.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-026"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Dahood, M. J. (1974), "), _c('i', [_vm._v("Psalms 51 – 100")]), _vm._v(", ABC (New York: Doubleday).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-027"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Day, J. (1975), "), _c('i', [_vm._v("God’s Conflict with the Dragon and the Sea: Echoes of a Canaanite Myth in the Old Testament ")]), _vm._v("(Cambridge, MA: Harvard University Press).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-028"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("deSilva, D. (2008), ‘Honor and Shame’, in T. Longman III and P. Enns (eds.), "), _c('i', [_vm._v("Dictionary of the Old Testament: Wisdom, Poetry and Writings ")]), _vm._v("(Downers Grove: IVP), 287–300.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-029"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Eriksson, L. O. (1991), "), _c('i', [_vm._v("‘Come, Children, Listen to Me!’: Psalm 34 in the Hebrew Bible and in Early Christian Writings ")]), _vm._v("(Stockholm: Almqvist and Wiksell International).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-030"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Estes, D. (2011), ‘Spirit and the Psalmist in Psalm 51’, in D. G. Firth and P. D. Wegner (eds.), "), _c('i', [_vm._v("Presence, Power and Promise: The Role of the Spirit of God in the Old Testament ")]), _vm._v("(Nottingham: Apollos), 122–134.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-031"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Firth, D. G. (2005), ‘The Teaching of the Psalms’, in D. G. Firth and P. S. Johnston (eds.), "), _c('i', [_vm._v("Interpreting the Psalms: Issues and Approaches ")]), _vm._v("(Downers Grove: IVP; Nottingham: Apollos), 159–174.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-032"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("––– (2005), "), _c('i', [_vm._v("Surrendering Retribution in the Psalms: Responses to Violence in the Individual Complaints ")]), _vm._v("(Milton Keynes: Paternoster).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-033"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("––– (2009), "), _c('i', [_vm._v("1 and 2 Samuel")]), _vm._v(", AOTC (Nottingham: Apollos).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-034"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Firth, D. G. and P. S. Johnston (eds.) (2005), "), _c('i', [_vm._v("Interpreting the Psalms: Issues and Approaches ")]), _vm._v("(Downers Grove: IVP; Leicester: Apollos).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-035"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Foster, J. L. (2006), ‘The Hymn to Aten: Akhenaten Worships the Sole God’, in J. M. Sasson (ed.), "), _c('i', [_vm._v("Civilizations of the Ancient Near East ")]), _vm._v("(Peabody, MA: Hendrickson), 1751–1761.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-036"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Fox, M. V. (2000), "), _c('i', [_vm._v("Proverbs 1 – 9")]), _vm._v(", ABC (New York: Doubleday).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-037"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Futato, M. D. (2009), "), _c('i', [_vm._v("The Book of Psalms ")]), _vm._v("(Carol Stream, IL: Tyndale House).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-038"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Gillmayr-Bucher, S. (2010), ‘Like Olive Shoots around Your Table: Images of Space in the Psalms of Ascent’ in E. Zenger (ed.), "), _c('i', [_vm._v("The Composition of the Book of Psalms ")]), _vm._v("(Leuven: Uitgeverij Peeters), 259–277.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-039"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Ginsberg, H. L. (1935), ‘A Phoenician Hymn in the Psalter’, "), _c('i', [_vm._v("XIX Congresso Internationale degli Orientalisti")]), _vm._v(", Rome.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-040"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Godfrey, W. R. (2013), ‘The Church and Psalm 81’, "), _c('i', [_vm._v("Tabletalk ")]), _vm._v("57: 66–67.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-041"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Goldingay, J. (2006), "), _c('i', [_vm._v("Psalms 1 – 41")]), _vm._v(", BCOTWP (Grand Rapids: Baker).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-042"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("––– (2007), "), _c('i', [_vm._v("Psalms 42 – 89")]), _vm._v(", BCOTWP (Grand Rapids: Baker).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-043"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("––– (2008), "), _c('i', [_vm._v("Psalms 90 – 150")]), _vm._v(", BCOTWP (Grand Rapids: Baker).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-044"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Green, D. J. (2010), ‘The Lord Is Christ’s Shepherd: Psalm 23 as Messianic Prophecy’, in P. Enns, et. al. (eds"), _c('i', [_vm._v(".")]), _vm._v("), "), _c('i', [_vm._v("Eyes to See, Ears to Hear: Essays in Memory of J. Alan Groves ")]), _vm._v("(Phillipsburg, NJ: Presbyterian & Reformed).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-045"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Guillaume, P. (2010), ‘Bull-Leaping in Psalm 18’, in P. van Hecke and A. Labahn (eds.), "), _c('i', [_vm._v("Metaphors in the Psalms ")]), _vm._v("(Leuven: Uitgeverij Peeters), 35–46.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-046"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Gunkel, H. (1968), "), _c('i', [_vm._v("Die Psalmen")]), _vm._v(", 5th edn (Göttingen: Vandenhoeck and Ruprecht).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-047"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Hausmann, J. (2010), ‘Zur Sprachwelt von Psalm 121’, in P. van Hecke and A. Labahn (eds.), "), _c('i', [_vm._v("Metaphors in the Psalms ")]), _vm._v("(Leeuven: Uitgeverij Peeters), 47–54.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-048"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Hilber, J. W. (2005), "), _c('i', [_vm._v("Cultic Prophecy in the Psalms ")]), _vm._v("(Berlin: Walter de Gruyter).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-049"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("––– (2009), ‘Psalms’, in J. H. Walton (ed.), "), _c('i', [_vm._v("Zondervan Illustrated Bible Backgrounds Commentary")]), _vm._v(", vol. 5. (Grand Rapids: Zondervan), 316–463.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-050"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Hossfeld, F.-L. and E. Zenger (1993), "), _c('i', [_vm._v("Die Psalmen 1 – 50, Die Neue Echter Bibel ")]), _vm._v("(Würzburg: Echter Verlag).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-051"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("––– (2005), "), _c('i', [_vm._v("Psalms 2: A Commentary on Psalms 51 – 100")]), _vm._v(", Hermeneia (Minneapolis: Fortress Press).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-052"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("––– (2011), "), _c('i', [_vm._v("Psalms 3: A Commentary on Psalms 101 – 150")]), _vm._v(", Hermeneia (Minneapolis: Fortress Press).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-053"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Howard, D. M. (1997), "), _c('i', [_vm._v("The Structure of Psalms 93 – 100 ")]), _vm._v("(Winona Lake, IN; Eisenbrauns).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-054"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Hubbard, D. A. (1973), "), _c('i', [_vm._v("Psalms for All Seasons ")]), _vm._v("(Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-055"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Hutchinson, J. (2005), ‘The Psalms and Praise’, in D. G. Firth and P. S. Johnston (eds.), "), _c('i', [_vm._v("Interpreting the Psalms: Issues and Approaches")]), _vm._v(" (Downers Grove: IVP; Nottingham: Apollos), 85–100.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-056"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Jacobsen, T. (1987), "), _c('i', [_vm._v("The Harps that Once… Sumerian Poetry in Translation ")]), _vm._v("(New Haven: Yale University Press).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-057"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Jacobson, R. A. and K. N. Jacobson (2013), "), _c('i', [_vm._v("Invitation to the Psalms: A Reader’s Guide for Discovery and Engagement ")]), _vm._v("(Grand Rapids: Baker).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-058"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Janowski, B. (2013), "), _c('i', [_vm._v("Arguing with God: A Theological Anthropology of the Psalms ")]), _vm._v("(Louisville: Westminster John Knox).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-059"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Johnston, P. S. (2002), "), _c('i', [_vm._v("Shades of Sheol ")]), _vm._v("(Downers Grove: IVP; Leicester: Apollos).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-060"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Keener, C. S. (2002), "), _c('i', [_vm._v("Revelation")]), _vm._v(", NIVAC (Grand Rapids: Zondervan).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-061"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Kidner, D. (1973), "), _c('i', [_vm._v("Psalms 1 – 72")]), _vm._v(", TOTC (Downers Grove/ Leicester: IVP).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-062"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("––– (1975), "), _c('i', [_vm._v("Psalms 73 – 150")]), _vm._v(", TOTC (Downers Grove/Leicester: IVP).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-063"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Klingbeil, M. G. (2010), ‘Metaphors that Travel and (Almost) Vanish: Mapping Diachronic Changes in the Intertextual Usage of the Heavenly Warrior Metaphor in Psalms 18 and 144’, in P. van Hecke and A. Labahn (eds.), "), _c('i', [_vm._v("Metaphors in the Psalms")]), _vm._v(" (Leuven: Uitgeverij Peeters), 115–134.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-064"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Kloos, C. (1986), "), _c('i', [_vm._v("Yhwh’s Combat with the Sea: A Canaanite Tradition in the Religion of Ancient Israel ")]), _vm._v("(Leiden: Brill).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-065"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Kraus, H.-J. (1988), "), _c('i', [_vm._v("Psalms 1 – 59: A Commentary ")]), _vm._v("(Minneapolis; Augsburg).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-066"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("––– (1993), "), _c('i', [_vm._v("Psalms 60 – 150: A Continental Commentary ")]), _vm._v("(Minneapolis: Fortress).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-067"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Kugel, J. (1981), "), _c('i', [_vm._v("The Idea of Biblical Poetry ")]), _vm._v("(New Haven: Yale University Press).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-068"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Kwakkel, G. (2010), ‘Under YHWH’s Wings’, in P. van Hecke and A. Labahn (eds.), "), _c('i', [_vm._v("Metaphors in the Psalms ")]), _vm._v("(Leuven: Uitgeverij Peeters), 141–165.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-069"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Kynes, W. (2012), "), _c('i', [_vm._v("My Psalm Has Turned into Weeping: Job’s Dialogue with the Psalms ")]), _vm._v("(Berlin: de Gruyter).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-070"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Lewis, C. S. (1961), "), _c('i', [_vm._v("Reflections on the Psalms ")]), _vm._v("(New York: Mariner Books).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-071"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Lockyer, H. (1984), ‘In Wonder of the Psalms’, "), _c('i', [_vm._v("Christianity Today")]), _vm._v(" 28: 72–78.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-072"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Longenecker, R. N. (2007), ‘Luke–Acts’, in T. Longman III and D. Garland (eds.), "), _c('i', [_vm._v("The Expositor’s Bible Commentary: Revised Edition")]), _vm._v(", vol. 10 (Grand Rapids: Zondervan), 663–1102.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-073"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Longman III, T. (1984), ‘Psalm 98: A Divine Warrior Victory Song’, "), _c('i', [_vm._v("JETS ")]), _vm._v("27: 290–307.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-074"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("––– (1988), "), _c('i', [_vm._v("How to Read the Psalms ")]), _vm._v("(Downers Grove: IVP).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-075"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("––– (1998), "), _c('i', [_vm._v("Ecclesiastes")]), _vm._v(", NICOT (Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-076"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("––– (2001), "), _c('i', [_vm._v("Immanuel in Our Place: Seeing Christ in Israel’s Worship ")]), _vm._v("(Phillipsburg, NJ: Presbyterian & Reformed).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-077"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("––– (2001), "), _c('i', [_vm._v("Song of Songs")]), _vm._v(", NICOT (Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-078"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("––– (2002), "), _c('i', [_vm._v("How to Read Proverbs ")]), _vm._v("(Downers Grove: IVP).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-079"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("––– (2005),‘The Psalms and Ancient Near Eastern Psalm Genres’, in D. Firth and P. S. Johnston (eds.), "), _c('i', [_vm._v("Interpreting the Psalms: Issues and Approaches ")]), _vm._v("(Downers Grove: IVP; Nottingham: Apollos, 2005), 41–59.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-080"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("––– (2006), "), _c('i', [_vm._v("Proverbs")]), _vm._v(". BCOTWP (Grand Rapids: Baker).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-081"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("––– (2007), ‘The Messiah: Explorations in the Law and Writings’, in S. E. Porter (ed.), "), _c('i', [_vm._v("The Messiah in the Old and New Testaments ")]), _vm._v("(Grand Rapids: Eerdmans), 13–34.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-082"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("––– (2010), ‘The Glory of God in the Old Testament’, in C. W. Morgan and R. A. Peterson (eds.), "), _c('i', [_vm._v("The Glory of God ")]), _vm._v("(Wheaton, IL: Crossway), 47–78.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-083"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("––– (2012), "), _c('i', [_vm._v("Job")]), _vm._v(", BCOTWP (Grand Rapids: Baker).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-084"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("––– (2013), ‘What Genesis 1 – 2 Teaches (and What It Doesn’t)’, in J. Daryl Charles (ed.), "), _c('i', [_vm._v("Reading Genesis 1 – 2 ")]), _vm._v("(Peabody, MA: Hendrikson), 103–128.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-085"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Longman III, T. and P. Enns (eds.) (2008), "), _c('i', [_vm._v("Dictionary of the Old Testament: Wisdom, Poetry and Writings ")]), _vm._v("(Downers Grove/ Nottingham: IVP).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-086"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Longman III, T. and D. Reid (1995), "), _c('i', [_vm._v("God Is a Warrior ")]), _vm._v("(Grand Rapids: Zondervan).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-087"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Mays, J. L. (1994), "), _c('i', [_vm._v("Psalms: Interpretation ")]), _vm._v("(Louisville: John Knox).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-088"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Miller, Jr, P. D. (1973), "), _c('i', [_vm._v("The Divine Warrior in Early Israel ")]), _vm._v("(Cambridge: Harvard University Press).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-089"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Mitchell, D. C. (1997), "), _c('i', [_vm._v("The Message of the Psalter: An Eschatological Programme in the Book of Psalms")]), _vm._v(", JSOTSup 252 (Sheffield: Sheffield Academic Press).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-090"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Moo, D. J. (2000), "), _c('i', [_vm._v("Romans")]), _vm._v(", NIVAC (Grand Rapids: Zondervan).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-091"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Moody, J. (2013), "), _c('i', [_vm._v("Journey to Joy: The Psalms of Ascent ")]), _vm._v("(Wheaton: Crossway).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-092"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Mowinckel, S. (1921–24), "), _c('i', [_vm._v("Psalmenstudien")]), _vm._v(", I–VI (Oslo).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-093"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("––– (1962), "), _c('i', [_vm._v("The Psalms in Israel’s Worship")]), _vm._v(", I–II (Oxford/New York: Abingdon Press).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-094"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Murphy, R. E. (1998), "), _c('i', [_vm._v("Proverbs")]), _vm._v(", WBC (Dallas: Word).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-095"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Pemberton, G. (2012), "), _c('i', [_vm._v("Hurting with God: Learning to Lament with the Psalms ")]), _vm._v("(Abiline, TX: ACU Press).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-096"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("––– (2014), "), _c('i', [_vm._v("After Lament: Psalms for Learning to Trust Again ")]), _vm._v("(Abiline, TX: ACU Press).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-097"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Peters, T. (1993), ‘Editor’s Introduction – Pannenberg on Theology and Natural Science’, in Wolfhart Pannenberg, "), _c('i', [_vm._v("Toward a Theology of Nature: Essays on Science and Faith ")]), _vm._v("(Louisville: Westminster John Knox).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-098"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Reardon, P. H. (2000), "), _c('i', [_vm._v("Christ in the Psalms ")]), _vm._v("(Chesterton, Indiana: Conciliar Press).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-099"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Riede, P. (2010), ‘Tischmotiv in den Psalmen 23 and 69’, in E. Zenger (ed.), "), _c('i', [_vm._v("The Composition of the Book of Psalms ")]), _vm._v("(Leuven: Uitgeverij Peeters), 217–233.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-100"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Ryken, L., J. C. Wilhoit, and T. Longman III (eds.) (1998), "), _c('i', [_vm._v("Dictionary of Biblical Imagery ")]), _vm._v("(Downers Grove/Leicester: IVP).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-101"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Seow, C. L. (2013), ‘An Exquisitely Poetic Introduction to the Psalter’, "), _c('i', [_vm._v("JBL ")]), _vm._v("132: 275–293.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-102"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Tate, M. (1991), "), _c('i', [_vm._v("Psalms 51 – 100")]), _vm._v(", WBC (Nashville: Thomas Nelson).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-103"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Terrien, S. (2003), "), _c('i', [_vm._v("The Psalms: Strophic Structure and Theological Commentary ")]), _vm._v("(Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-104"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("van Hecke, P. and A. Labahn (eds.) (2010), "), _c('i', [_vm._v("Metaphors in the Psalms")]), _vm._v(" (Leuven: Uitgeverij Peeters).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-105"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("VanGemeren, W. A. (2008), "), _c('i', [_vm._v("Psalms")]), _vm._v(", REBC (Grand Rapids: Zondervan).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-106"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Wakeman, M. K. (1973), "), _c('i', [_vm._v("God’s Battle with the Monster: A Study in Biblical Imagery ")]), _vm._v("(Leiden: Brill).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-107"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Walker, C. and M. B. Dick (1999), ‘The Induction of the Cult Image in Ancient Mesopotamia: The Mesopotamian "), _c('i', [_vm._v("mīs pî ")]), _vm._v("Ritual’, in "), _c('i', [_vm._v("Born in Heaven Made on Earth: The Making of the Cult Image in the Ancient Near East ")]), _vm._v("(Winona Lake, IN: Eisenbrauns), 55–122.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-108"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Waltke, B. K. (1991), ‘Superscripts, Postscripts, or Both’, "), _c('i', [_vm._v("JBL ")]), _vm._v("110: 583–596.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-109"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("––– (2013), "), _c('i', [_vm._v("The Dance between God and Humanity: Reading the Bible with the People of God ")]), _vm._v("(Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-110"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Waltke, B. K. and J. M. Houston (2010), "), _c('i', [_vm._v("The Psalms as Christian Worship: A Historical Commentary ")]), _vm._v("(Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-111"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Walton, J. (2009), "), _c('i', [_vm._v("The Lost World of Genesis 1 ")]), _vm._v("(Downers Grove: IVP).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-112"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("––– (2011), "), _c('i', [_vm._v("Genesis 1 as Ancient Cosmology ")]), _vm._v("(Winona Lake, IN: Eisenbrauns).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-113"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Watson, W. G. E. (1984), "), _c('i', [_vm._v("Classical Hebrew Poetry: A Guide to Its Techniques")]), _vm._v(", JSOTS 26 (Sheffield: Sheffield Academic Press).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-114"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Weiser, A. (1962), "), _c('i', [_vm._v("The Psalms")]), _vm._v(", OTL (Philadelphia: Westminster Press).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-115"
    }
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "p22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Westermann, C. (1989), "), _c('i', [_vm._v("The Living Psalms ")]), _vm._v("(Grand Rapids: Eerdmans).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-116"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Wilson, G. H. (1985), "), _c('i', [_vm._v("The Editing of the Hebrew Psalter ")]), _vm._v("(Chico, CA: Scholars’ Press).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-117"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("––– (2002), "), _c('i', [_vm._v("Psalms")]), _vm._v(", vol. 1, NIVAC (Grand Rapids: Zondervan).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-118"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Wright, N. T. (2013), "), _c('i', [_vm._v("The Case for the Psalms: Why They Are Essential")]), _vm._v(" (San Francisco: HarperCollins).")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-119"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Zenger, E. (ed.) (2010), "), _c('i', [_vm._v("The Composition of the Book of Psalms")]), _vm._v(" (Leuven: Uitgeverij Peeters).")])])])])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30fb2ae4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre5.vue
// module id = 75
// module chunks = 0